module.exports = __webpack_public_path__ + "img/ABLFrictionHighSpeedJettingSettings-min.fd7449ae.png";